import React from 'react';

const processSteps = [
  {
    number: "01",
    title: "Discovery & Strategy",
    description: "We dive deep into your requirements, market, and audience to build a solid project roadmap.",
    icon: (
      <svg className="w-8 h-8 text-[#f58327]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    )
  },
  {
    number: "02",
    title: "UI/UX Design",
    description: "Creating wireframes and stunning interfaces that provide an intuitive and engaging user experience.",
    icon: (
      <svg className="w-8 h-8 text-[#f1833b]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
      </svg>
    )
  },
  {
    number: "03",
    title: "Development",
    description: "Our engineers build robust, scalable, and high-performance solutions using cutting-edge technologies.",
    icon: (
      <svg className="w-8 h-8 text-[#f1833b]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    )
  },
  {
    number: "04",
    title: "Testing & Launch",
    description: "Rigorous QA testing ensures a bug-free product, followed by a smooth deployment to production.",
    icon: (
      <svg className="w-8 h-8 text-[#f1833b]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
      </svg>
    )
  }
];

export default function ProjectsProcess({ data }) {
  const activeSteps = data?.processes?.length > 0 ? data.processes.map((p, i) => ({
    number: `0${i + 1}`.slice(-2),
    title: p.title,
    description: p.description,
    icon: processSteps[i % processSteps.length].icon // Fallback to predefined icons for visual appeal
  })) : processSteps;

  const title = data?.title || "Our Delivery Process";
  const subtitle = data?.subtitle || "We follow a streamlined, agile methodology to ensure your project is delivered on time, within budget, and exceeds expectations.";

  return (
    <section className="py-20 relative w-full">
      {/* Background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-[#f1833b]/5 blur-[120px] rounded-full pointer-events-none z-0"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-[1360px]">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-[#f1833b] font-medium text-sm tracking-wider uppercase mb-3">How We Build</h2>
          <h3 className="text-3xl md:text-4xl lg:text-[40px] font-bold text-white mb-6">{title}</h3>
          <p className="text-[#9ca3af] text-base md:text-[18px] leading-relaxed whitespace-pre-wrap">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {activeSteps.map((step, index) => (
            <div 
              key={index}
              className="bg-[#0f0f0fd9] rounded-2xl p-8 border-[1px] border-solid border-[#ffffff1a] hover:border-[#f1833b]/50 hover:bg-[#151515] hover:-translate-y-2 transition-all duration-300 group relative overflow-hidden"
            >
              {/* Step Number Watermark */}
              <div className="absolute -right-4 -bottom-4 text-[120px] font-bold text-white/[0.03] group-hover:text-[#f1833b]/[0.05] transition-colors duration-500 pointer-events-none leading-none">
                {step.number}
              </div>

              {/* Icon */}
              <div className="w-16 h-16 rounded-xl bg-[#1a1a1a] flex items-center justify-center mb-6 group-hover:bg-[#f1833b]/10 transition-colors duration-300">
                {step.icon}
              </div>

              <h4 className="text-[18px] md:text-[20px] font-bold text-white mb-4 group-hover:text-[#f1833b] transition-colors duration-300">
                {step.title}
              </h4>
              
              <p className="text-[#9ca3af] leading-[1.375] text-[14px]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
